export const DIR_LEFT = 'left';
export const DIR_RIGHT = 'right';

export const APP_GREY = '#686868';